import { Choice } from '../object/object';

export const bidIdKey = (shift) => `${shift.shiftType}_bid_${shift.id}`;

export const typeInfo = {
  vaccination: {
    modifier: 'vaccine',
    label: 'Clinic Limited-Service',
    isHospital: false,
  },
  hospital: {
    modifier: 'fullHospital',
    label: 'Hospital Full-Service',
    isHospital: true,
  },
  hospital_dynamic: {
    modifier: 'dynamicHospital',
    label: 'Hospital',
    isHospital: true,
  },
  wellness: {
    modifier: 'limitedHospital',
    label: 'Hospital Limited-Service',
    isHospital: true,
  },
};

export const typeOptions = Object.keys(typeInfo).map((key) => ({
  value: key,
  label: typeInfo[key].label,
}));

export const BidStatus = Choice({
  IN_REVIEW: 'in_review',
  APPROVED: 'approved',
  DECLINED: 'declined',
  CANCELED: 'canceled',
  WITHDRAWN: 'withdrawn',
});

export const ShiftStatus = Choice({
  CREATED: 'created',
  OPEN_FOR_BIDDING: 'open_for_bidding',
  PENDING: 'pending',
  CLOSED: 'closed',
  IN_PROGRESS: 'in_progress',
  FINISHED: 'finished',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
});

export const ShiftTypes = Choice({
  VACCINATION: 'vaccination',
  HOSPITAL: 'hospital',
  HOSPITAL_DYNAMIC: 'hospital_dynamic',
  WELLNESS: 'wellness',
});

export const dynamicShiftOptions = {
  services: [
    { name: 'wellness', label: 'Wellness', unchangeable: true },
    { name: 'sickPets', label: 'Sick Pets', unchangeable: false },
  ],
  areas: [
    { name: 'dental', label: 'Dental' },
    { name: 'surgery', label: 'Surgery' },
    { name: 'euthanasia', label: 'Euthanasia' },
  ],
};

export const getDynamicShiftOptionsSelected = (values, label) => {
  const dynamicShiftOptionsSelected = { services: [], areasOfPractice: [] };

  Object.entries(values).forEach(([key, value]) => {
    if (!value) return;

    const service = dynamicShiftOptions.areas.find((item) => item.name === key);

    if (service) {
      dynamicShiftOptionsSelected.services.push(service[label]);
    }

    const area = dynamicShiftOptions.areas.find((item) => item.name === key);

    if (area) {
      dynamicShiftOptionsSelected.areasOfPractice.push(area[label]);
    }
  });

  return dynamicShiftOptionsSelected;
};

export const isBidAmountHigh = (bidKey, values) => values[bidKey] >= 10000;

